<script lang="ts">

    // CASSIOPEIA

    import { IS_AUTHENTICATED, IS_ORGANIZATION_APPROVED, SUBSCRIPTION_STORE, SUBSCRIPTION_API, SESSION_USER } from '@smatch/cassiopeia-web-components';

    // UTILS

    import { useNavigate } from 'svelte-navigator';
    import { onMount } from 'svelte';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const navigate = useNavigate();

    /* INTERNALS ------------------------------------------------------------------------------- */

    // eslint-disable-next-line complexity, max-statements, max-lines-per-function
    const onStateChange = (isAuthenticated: boolean, isApproved: boolean, hasSubscriptions: boolean): void => {

        const { pathname: PATH_NAME } = window.location;

        if (isAuthenticated && isApproved) {
            navigate('/subscriptions/create');
            return;
        }

        if (isAuthenticated && hasSubscriptions) {
            navigate('/landing/sourcing-agent-success');
            return;
        }

        if (PATH_NAME !== '/landing/sourcing-agent') {
            navigate('/landing/sourcing-agent');
        }

    };

    $: onStateChange($IS_AUTHENTICATED, $IS_ORGANIZATION_APPROVED, Object.values($SUBSCRIPTION_STORE).length > 0);
    $: void SUBSCRIPTION_API.filterSubscriptions({ ownerKey: $SESSION_USER?._.key });

    onMount((): void => {
        if (!$IS_AUTHENTICATED) {
            return;
        }
        // Need to fetch the subscriptions on page reload
        void SUBSCRIPTION_API.filterSubscriptions({ ownerKey: $SESSION_USER?._.key });
    });

</script>

{#if !$IS_ORGANIZATION_APPROVED}
    <slot />
{/if}